import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TeamRole } from 'src/app/core/models/project-pilot.model';
import { ConfirmationPopupComponent } from 'src/app/shared/component/confirmation-popup/confirmation-popup.component';
import { Message, PrivilegeType, TableData } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
import { ProjectPilotService } from 'src/app/shared/services/project-pilot.service';
import { ManageTeamRoleComponent } from '../manage-team-role/manage-team-role.component';
@Component({
  selector: 'app-team-roles',
  templateUrl: './team-roles.component.html',
  styleUrls: ['./team-roles.component.scss']
})
export class TeamRolesComponent implements OnInit {
  public tableData: TableData = { content: [] } as TableData;
  public roles: TeamRole[] =[];
  public pageSizes: number[] = [];
  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public privilege: PrivilegeType;
  private pageDataKey: string = 't-r';

  constructor(
    private modalService: NgbModal,
    private commonService: CommonService,
    private dataService: DataService,
    private projectPilotService: ProjectPilotService
  ) { }

  ngOnInit(): void {
    this.pageSizes = this.commonService.getDefaultPageSizes();
    this.tableData = this.commonService.getDefaultPageData(this.pageDataKey);
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });//TODO Implement later
    this.getTeamRoles();
  }

  // private getTeamRoles(clear: boolean = true) {
  //   if (clear) {
  //     this.isLoading = true;
  //     this.tableData.content = [];
  //   }
  //   const pageSize = Number(this.tableData.size);
  //   const pageNumber = Math.max(1, Number(this.tableData.number) || 1);
  //   this.projectPilotService.getTeamRoles(pageNumber - 1, pageSize, null, true).subscribe({
  //     next: (tableData: TableData) => {
  //       this.tableData = tableData;
  //       this.tableData.size = pageSize;
  //       this.tableData.content = this.tableData?.content?.sort((a, b) => a.id - b.id);
  //       this.roles = [...this.tableData.content]; 
  //       this.isLoading = false;
  //     },
  //     error: (error: HttpErrorResponse) => {
  //       this.isLoading = false;
  //       this.commonService.setToastr(500, error?.error?.name || error.error);
  //     }
  //   });
  // }

  private getTeamRoles(clear: boolean = true, pageNumber: number = 0): void {
    if (clear) {
      this.isLoading = true;
      this.tableData.content = [];
    }
  
    const pageSize = Number(this.tableData.size);
  
    this.projectPilotService.getTeamRoles(pageNumber, pageSize, null, true).subscribe({
      next: (tableData: TableData) => {
        this.tableData = {
          ...tableData,
          number: pageNumber + 1, // Adjust for 1-based page display
        };
        this.tableData.size = pageSize;
        this.tableData.content = this.tableData?.content?.sort((a, b) => a.id - b.id);
        this.roles = [...this.tableData.content];
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.commonService.setToastr(500, error?.error?.name || error.error);
      }
    });
  }
  

  public deleteTeamRole(role: TeamRole, index: number) {
    if (!this.privilege.canDelete) return;
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.title = "Role deletion";
    modalRef.componentInstance.prefixMessage = "Are you sure you want to delete role";
    modalRef.componentInstance.message = role.name;
    modalRef.componentInstance.label = 'role';
    modalRef.result.then((isConfirmed: boolean) => {
      if (isConfirmed) {
        role.isDeleteInProgress = true;
        this.projectPilotService.deleteTeamRole(role.id).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.commonService.setToastr(200, response.message);
              this.tableData?.content.splice(index, 1);
              this.getTeamRoles(false);
              role.isDeleteInProgress = false;
            } else {
              this.commonService.setToastr(500, response.message);
              role.isDeleteInProgress = false;
            }
          },
          error: (error: HttpErrorResponse) => {
            this.commonService.setToastr(500, error?.error?.name || error.error);
            role.isDeleteInProgress = false;
          },
        });
      }
    });
  }

  public upsertTeamRole(role?: TeamRole) {
    if (!this.privilege.canEdit) return;
    const modalRef = this.modalService.open(ManageTeamRoleComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.role = role;
    modalRef.componentInstance.roles = this.roles;
    modalRef.result.then((response: Message) => {
      if (!response?.failed) {
        this.getTeamRoles(false);
      }
    })
  }

  public toggleTeamRoleStatus(role: TeamRole) {
    if (!this.privilege.canEdit) {
      setTimeout(() => { role.disabled = !role.disabled }, 0);
      return;
    }
    const newDisabledState = !role.disabled;

    this.projectPilotService.toggleTeamRoleStatus(role.id, newDisabledState).subscribe({
      next: (response: Message) => {
        if (!response.failed) {
          // Only update role.disabled after a successful API call
          role.disabled = newDisabledState;
          this.commonService.setToastr(200, `Team ${role.name} is now ${newDisabledState ? 'disabled' : 'enabled'}!`);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.commonService.setToastr(500, error?.error?.name || error.error);
      },
    });
  }

  public getPrivilegeById(privilege: string): string {
    return this.projectPilotService.getPrivileges()?.find(p => p.id === privilege)?.label;
  }

  public loadTableData(e) {
    this.tableData.size = Number(this.tableData.size);
    this.tableData.number = 1;
    this.commonService.storePageData(this.pageDataKey, this.tableData.size, this.tableData.number);
    this.getTeamRoles(false);
  }

  public onPageChange(newPage: number): void {
    this.tableData.number = newPage; 
    const pageNumber = newPage - 1;  
    this.getTeamRoles(false, pageNumber);
  }
}
